import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type MapleMarkProps = {
  size?: number;
  className?: string;
  animated?: boolean;
};
const LEAF = "M24 4L28.5 15.5L39 10.5L35 21L44 24L35 27L39 37.5L28.5 32.5L24 44L19.5 32.5L9 37.5L13 27L4 24L13 21L9 10.5L19.5 15.5L24 4Z";
export function MapleMark({
  size = 40,
  className = "",
  animated = false
}: MapleMarkProps) {
  const reduce = useReducedMotion();
  const draw = animated && !reduce;
  return <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} role="img" aria-label="Maple Canadian College mark" data-id="element-301" data-mp="1x684jzh7d0bt">
      <motion.path d={LEAF} stroke="currentColor" strokeWidth="2.1" strokeLinejoin="round" strokeLinecap="round" initial={draw ? {
      pathLength: 0
    } : false} animate={draw ? {
      pathLength: 1
    } : undefined} transition={{
      duration: 1.1,
      ease: [0.65, 0, 0.35, 1]
    }} data-id="element-302" data-mp="1ndiw7dgy82kp" />
      <motion.path d="M24 44V30" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" initial={draw ? {
      pathLength: 0
    } : false} animate={draw ? {
      pathLength: 1
    } : undefined} transition={{
      duration: 0.4,
      delay: 0.9,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-303" data-mp="2b2u1n898ul56" />
    </svg>;
}